var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiFindPatentFolders } from '@/infrastructure/api-functions/api-find-patent-folders';
import _ from 'lodash';
import { batchProxy } from '@/infrastructure/utils/batch-proxy';
export const WORKSPACE_URI = Symbol('WORKSPACE_URI');
let PatentFoldersServiceImp = class PatentFoldersServiceImp {
    constructor(_apiFindPatentFolders, _workspaceUri) {
        this._apiFindPatentFolders = _apiFindPatentFolders;
        this._workspaceUri = _workspaceUri;
        this._batchFn = batchProxy((patentIds) => {
            /* batchProxy 没有去重逻辑，此处的接口接收重复 id 时会报错 */
            const patent_ids = _.uniq(patentIds);
            return this._apiFindPatentFolders.findPatentFolders({ patent_ids });
        }, 500);
    }
    async findFoldersByPatentId(patentId) {
        const resp = await this._batchFn([patentId]);
        const rs = resp.filter(item => item.patent_id === patentId);
        if (rs.length === 0) {
            return [];
        }
        const results = _.map(rs[0].workspace_infos, (item => {
            return {
                folderId: item.folder_id,
                folderName: item.folder_name,
                spaceId: item.space_id,
                spaceName: item.space_name,
                cover: item.space_s3_key || this._getCoverUrl(item.space_icon),
                isRoot: item.is_root,
            };
        }));
        return Promise.resolve(results);
    }
    _getCoverUrl(code) {
        return `${this._workspaceUri}/a-workspace/permanent/space-covers/${code}.png`;
    }
};
PatentFoldersServiceImp = __decorate([
    injectable(),
    __param(0, inject(ApiFindPatentFolders)),
    __param(1, inject(WORKSPACE_URI)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiFindPatentFolders !== "undefined" && ApiFindPatentFolders) === "function" ? _a : Object, String])
], PatentFoldersServiceImp);
export { PatentFoldersServiceImp };
